import _ from 'lodash'
import type { BeaconRun } from '../../utils/api-client/api-schemas.ts'
import * as styles from './beacon-run-summary-strip.css.ts'
import { pillFromRun, runProgressOf, verifiedFindingsOf } from './beacon-run.ts'
import { BeaconScanningPill } from './beacon-scanning-pill.tsx'

const formatCount = (value: number | null | undefined) => value ?? '—'

const formatPercent = (value: number | null | undefined) =>
  value === null || value === undefined ? '—' : `${Math.round(value * 10) / 10}%`

/** A run at a glance, from the platform's snapshot alone: its status, what it kept, how much it examined. */
export const RunSummaryStrip: React.FC<{ run: BeaconRun }> = ({ run }) => (
  <section className={styles.strip} aria-label="Beacon run summary">
    <BeaconScanningPill pill={pillFromRun(run)} />
    <dl className={styles.facts}>
      <div className={styles.fact}>
        <dt>Verified findings</dt>
        <dd>{formatCount(verifiedFindingsOf(run))}</dd>
      </div>
      <div className={styles.fact}>
        <dt>Attack surface examined</dt>
        <dd>{formatPercent(runProgressOf(run)?.examined_percent)}</dd>
      </div>
      <div className={styles.fact}>
        <dt>Effort</dt>
        <dd>{_.capitalize(run.effort)}</dd>
      </div>
    </dl>
  </section>
)
